import React from 'react'
import './FileTab.scss'

const FileTab = () => {
  return (
    <div>FileTab</div>
  )
}

export default FileTab